import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-grid">
        {/* Brand */}
        <div className="footer-brand">
          <div className="footer-logo">
            <img src="/apex%20logo%20small.png" alt="Apex DeFi Labs Inc." className="footer-logo-mark" />
            <span className="footer-logo-main">Apex DeFi Labs Inc.</span>
          </div>
          <p>Building legally compliant, AI-powered infrastructure for tokenized securities across U.S. alternative investment markets.</p>
          <p>info@apexdefilabs.com &nbsp;·&nbsp; +1-888-666-0441</p>
          <p style={{ marginTop: 14 }}>244 Fifth Ave Suite V255, New York City, NY 10001</p>
        </div>

        {/* Subsidiaries */}
        <div>
          <div className="footer-col-title">Subsidiaries</div>
          <ul className="footer-links">
            <li><Link to="/subsidiaries">DeFi Assets LLC</Link></li>
            <li><Link to="/subsidiaries">AI Adya LLC</Link></li>
            <li><Link to="/subsidiaries">Vivasvat Revolutions</Link></li>
          </ul>
        </div>

        {/* Ventures & Platform */}
        <div>
          <div className="footer-col-title">Ventures &amp; Platform</div>
          <ul className="footer-links">
            <li><Link to="/portfolio">Veep Capital · VYASA</Link></li>
            <li><a href="https://novaeralabs.us" target="_blank" rel="noopener noreferrer">Nova Era Labs</a></li>
            <li><Link to="/portfolio">OmniHealthX</Link></li>
            <li><a href="https://vruddhix.com" target="_blank" rel="noopener noreferrer">VruddhiX</a></li>
            <li><Link to="/portfolio">VYASA Platform</Link></li>
          </ul>
        </div>

        {/* Corporate */}
        <div>
          <div className="footer-col-title">Corporate</div>
          <ul className="footer-links">
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/vision-and-mission">Vision &amp; Mission</Link></li>
            <li><Link to="/leadership">Leadership</Link></li>
            <li><Link to="/investor-relations">Investor Relations</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/disclaimer">Legal Disclaimer</Link></li>
            <li><Link to="/risk-disclosure-summary">Risk Disclosure</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-disclaimer">
        <strong>Disclaimer:</strong> Apex DeFi Labs Inc. and its subsidiaries operate at the intersection of technology and regulated financial services.
        Investment offerings, where applicable, are conducted exclusively through registered broker-dealers and comply with applicable U.S. securities laws.
        Content on this website is for informational purposes only and does not constitute investment advice or an offer to sell securities.
        VYASA and associated brand names are proprietary platforms of Apex DeFi Labs Inc. and its subsidiaries.
      </div>

      <div className="footer-bottom">
        <div className="footer-copy">© 2024–{new Date().getFullYear()} Apex DeFi Labs Inc. All Rights Reserved.</div>
        <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.22)' }}>DeFi Assets LLC · AI Adya LLC · Vivasvat Revolutions Ltd</div>
        <div className="footer-legal">
          <Link to="/privacy-policy">Privacy</Link>
          <Link to="/terms-and-condition">Terms</Link>
          <Link to="/disclaimer">Disclaimer</Link>
        </div>
      </div>
    </footer>
  );
}
